import { useEffect } from 'react';

import { useAppSelector } from '@/Application/Hooks/Redux';
import { useRepository } from '@/Application/Providers/Repository';
import { selectBuyNowCartData } from '@/Application/Selectors/buyNow/useBuyNowCart';

export const useAlternativePayments = () => {
  const repositories = useRepository();
  const buyNowRepository = repositories.buyNowRepository;

  const cart = useAppSelector(selectBuyNowCartData);

  useEffect(() => {
    if (cart?.id) {
      buyNowRepository?.getAlternativePayments(cart.id);
    }
  }, [cart, buyNowRepository]);
};

export default useAlternativePayments;
